/** Steps after which a drying project's Projekt section locks: Schadenaufnahme result (7) to Projektabschluss (18). */
export const PROJECT_SECTION_LOCKING_STEPS_DRYING = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];

/** Step after which a leak detection project's Projekt section locks: the leak detection result (5). */
export const PROJECT_SECTION_LOCKING_STEPS_LEAK_DETECTION = [5];

/**
 * Whether an existing project's Projekt section (name, start, branch, type, order kind, numbers) is
 * locked because the project has progressed past the steps that fix these values. A user with
 * `ALWAYS_ALLOWED_TO_EDIT_PROJECT` may still edit a locked section; see {@link canEditProjectSection}.
 *
 * @param projectSteps the project's recorded steps, keyed by step number as a string
 * @param isLeakDetectionProject whether the project is a leak detection (`_ld`) project
 */
export function isProjectSectionLocked(
  projectSteps: Record<string, unknown> | null | undefined,
  isLeakDetectionProject: boolean
): boolean {
  if (!projectSteps) {
    return false;
  }

  const lockingSteps = isLeakDetectionProject
    ? PROJECT_SECTION_LOCKING_STEPS_LEAK_DETECTION
    : PROJECT_SECTION_LOCKING_STEPS_DRYING;

  return lockingSteps.some((step) => !!projectSteps[step.toString()]);
}

/**
 * Whether the Projekt section offers editing at all. A locked section leaves nothing editable for a
 * user without `ALWAYS_ALLOWED_TO_EDIT_PROJECT`, so the dialog must not offer BEARBEITEN to them.
 */
export function canEditProjectSection(isLocked: boolean, isAlwaysAllowedToEditProject: boolean): boolean {
  return !isLocked || isAlwaysAllowedToEditProject;
}
